export enum GA_EVENT {
  VIEW = 'page_view',
  CLICK_SEARCH = 'search',
  CLICK_BANNER = 'banner',
  CLICK_CONTENT = 'content',
  CLICK_PURCHASE = 'purchase',
  CLICK_MORE = 'more',
  CLICK_ALARM = 'alarm',
  CLICK_CATEGORY = 'category',
  CLICK_CLOSE = 'close',
  CLICK_BACK = 'back',
  CLICK_KWD = 'kwd',
  CLICK_CLEAR = 'clear',
  CLICK_CLEAR_ALL = 'clear_all',
  CLICK_RECENT_KWD = 'recent_kwd',
  CLICK_RECENT_KWD_CLEAR = 'recent_clear',
  CLICK_CLIP_CONTENT = 'content',
}

export enum LOCATION {
  MAIN = 'main',
  SEARCH = 'search',
  SEARCH_RESULT = 'search_result',
  CURATION = 'curation',
  SCHEDULE = 'schedule',
}

export enum BROADCAST_STATE_CODE {
  ACCEPTED = 'accepted',
  CANCEL = 'cancel',
  CONVERTING = 'converting',
  ERROR = 'error',
  ON_AIR = 'onair',
  READY = 'ready',
  REHEARSAL = 'rehearsal',
  REHEARSAL_ON_AIR = 'rehearsalonair',
  SIGN_OFF = 'signoff',
  STAND_BY = 'standby',
  SWITCHING = 'switching',
  VOD = 'vod',
  WARNING = 'warning',
}

export enum GA_BROADCAST_TYPE_CODE {
  LIVE = 'live',
  READY = 'ready',
  VOD = 'vod',
}
